import { MessageBox,Message,Loading } from 'element-ui';

let msgInstance = null;
let loading = null;

// 开启加载
export function openLoading () {
  loading = Loading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.3)'
  })
}

// 关闭加载
export function closeLoading () {
  loading && loading.close()
}

// 各类型消息
export function getMsgInstance() {
  return msgInstance
}

export function msgSuccess (msg) {
  msgInstance && msgInstance.close();
  msgInstance = Message({
    message: msg,
    type: 'success'
  })
}

export function msgError (msg) {
  msgInstance && msgInstance.close();
  msgInstance = Message({
    message: msg,
    type: 'error'
  })
}

export function msgWarning (msg) {
  msgInstance && msgInstance.close();
  msgInstance = Message({
    message: msg,
    type: 'warning'
  })
}

export function msgInfo (msg) {
  msgInstance && msgInstance.close();
  msgInstance = Message({
    message: msg,
    type: 'info'
  })
}

export function openAlert(msg) {
  MessageBox.alert(msg, "提示", {
    confirmButtonText: '确定',
    type: 'warning'
  });
}

// 确认框
export function openConfirm (message, sureFn) {
  MessageBox.confirm('确定要' + message + '？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(sureFn).catch(() => {
    msgInfo('您已取消操作！')
  })
}
